import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import logo from "@/assets/insonUchun.svg";

interface AppHeaderProps {
  userName: string | null;
  totalCollected: string;
}

export function AppHeader({ userName: _userName }: AppHeaderProps) {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="pt-4 pb-4"
    >
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 shrink-0 rounded-full flex items-center justify-center">
          <img src={logo} alt={t("appName")} className="object-contain" />
        </div>
        <h1 className="text-foreground font-bold text-xl truncate">{t("appName")}</h1>
      </div>
    </motion.div>
  );
}
